<!-- navbar-expand-md -->
<nav class="navbar navbar-expand navbar-light">
  <a class="navbar-brand" [routerLink]="['/']">
    <img [src]="currentUseInfo?.role === 'Customer' ? 'assets/img/logo-customer.png' : 
            currentUseInfo?.role === 'Driver' ? 'assets/img/logo-driver.png' : 
            'assets/img/logo.png'" />
  </a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarNav"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav ml-auto align-items-center">
      <!-- <li class="nav-item active">
        <a class="nav-link" [routerLink]="['/customer/book-ride']">Ride</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/driver/dashboard']">Drive</a>
      </li> -->
      <li class="nav-item">
        <a
          class="nav-link with-noti-count"
          id="notiBtn"
          (click)="clickNotification()"
          [routerLink]="['settings']"
        >
          <i class="fa fa-bell-o"></i>
          <span class="noti-count">{{
            currentUseInfo.unreadNotification
          }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/help']">Help</a>
      </li>
      <li class="nav-item">
        <div class="dropdown">
          <a
            *ngIf="currentUseInfo"
            class="dropdown-toggle"
            id="about-us"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              [src]="
                currentUseInfo?.image
                  ? currentUseInfo?.image
                  : 'assets/img/user.png'
              "
            />
            <span class="current-user-name">{{ currentUseInfo.name }}</span>
          </a>
          <div class="dropdown-menu" aria-labelledby="about-us">
            <a
              class="dropdown-item"
              [routerLink]="[
                currentUseInfo?.role === 'Customer'
                  ? '/customer/customer-profile'
                  : '/driver/driver-profile'
              ]"
              >My Profile</a
            >
            <a
              class="dropdown-item"
              [routerLink]="[
                currentUseInfo?.role === 'Customer'
                  ? '/customer/dashboard'
                  : '/driver/dashboard'
              ]"
              >Dashboard</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Customer'"
              [routerLink]="['/customer/my-trips']"
              >My Trips</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Driver'"
              [routerLink]="['/driver/my-trips']"
              >My Trips</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Customer'"
              [routerLink]="['/customer/payment']"
              >Payment</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Driver'"
              [routerLink]="['/driver/my-earning']"
              >My Earning</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Driver'"
              [routerLink]="['/driver/withdraw-history']"
              >Withdrawal History</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Customer'"
              [routerLink]="['/customer/offers']"
              >Offers</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Driver'"
              [routerLink]="['/driver/offers']"
              >Offers</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Customer'"
              [routerLink]="['/customer/wooffer-pay']"
              >Wooffer Wallet</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Customer'"
              [routerLink]="['/customer/legal']"
              >Legal</a
            >
            <a
              class="dropdown-item"
              *ngIf="currentUseInfo?.role === 'Driver'"
              [routerLink]="['/driver/legal']"
              >Legal</a
            >
            <a class="dropdown-item" [routerLink]="['settings']">Settings</a>
            <a class="dropdown-item" (click)="LogoutUser()">Logout</a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</nav>
